import React from 'react';

interface GoogleDriveIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    sx?: {
        fontSize?: number | string;
        filter?: string;
    };
}

const GoogleDriveIcon: React.FC<GoogleDriveIconProps> = (props) => {
    const { sx, ...otherProps } = props;
    return (
        <img
            src="https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg"
            alt="Google Drive"
            {...otherProps}
            style={{
                width: props.width || sx?.fontSize || 24,
                height: props.height || sx?.fontSize || 24,
                filter: sx?.filter,
                ...props.style
            }}
        />
    );
};

export default GoogleDriveIcon;
